<!--排序 SORT-->
<template>
	<div class="question-container" style="border: 1px solid #edeff2">
		<div class="question-type">排序</div>
		<div class="title-view" :style="{ marginRight: '' }">
			<p style="color: #4c4a56">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				{{ `${index + 1}、` }}
				<span style="color: #4c4a56">
					{{ `${dataObj.caseProblem}` }}
				</span>
			</p>
		</div>
		<div class="question-images">
			<div v-for="(item, index) in images" :key="index" style="margin-top: 10px; position: relative">
				<img :src="item" mode="widthFix" style="width: 100%" />
			</div>
		</div>
		<div v-for="(item, index) in list" :key="index">
			<div class="choose-css choose-css-new" style="
          border: 1px solid rgba(237, 237, 237, 0.5);
          background: rgba(247, 247, 247, 1);
        " @click="handleChoose(item, index)">
				<div class="choose-css-text">
					<p style="
              white-space: normal;
              word-break: break-all;
              color: rgba(43, 47, 54, 1);
            ">
						{{ item.text }}
					</p>
					<div class="select-icon" style="
						  border: 1px solid rgba(237, 237, 237, 1);
						  background: #ffffff;
						">
						<span v-if="item.orderNum > 0" class="sort-num">
							{{ item.orderNum }}
						</span>
					</div>
				</div>
				<div class="question-images">
					<div class="question-images-box" @click.stop="showBigImage(imgItem, item)"
						v-for="(imgItem, imgIndex) in item.img_path" :key="imgIndex"
						style="margin-top: 10px; position: relative">
						<img :src="imgItem" mode="aspectFill" class="thumbnail-image" />
						<div class="fangda-box">查看图片</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			params: {
				type: Object,
				default: {},
			},
		},
		data() {
			return {
				dataObj: {},
				index: 0,
				list: [],
				images: [],
				value: "",
			};
		},
		methods: {},
		watch: {
			params: {
				handler(newVal) {
					this.dataObj = newVal.data;
					this.index = newVal.index;

					this.images = JSON.parse(newVal.data.caseProblemImg || "[]");
					this.list = JSON.parse(newVal.data.chooseList).list;

					// 处理答案（排序题）
					if (
						newVal.answer &&
						newVal.answer.answer &&
						newVal.answer.answer.length > 0
					) {
						var answerArr = newVal.answer.answer;

						// 先清空每个选项的排序序号
						this.list.forEach(function(item) {
							item.orderNum = 0;
						});

						// 遍历答案，把 context 写入对应项
						answerArr.forEach((ans, i) => {
							var order = Number(ans.context);
							// context === 0 说明没排序，不处理
							if (order > 0) {
								this.list[i].orderNum = order;
							}
						});
					}
				},
				deep: true,
				immediate: true,
			},
		}

	};
</script>

<style scoped>
	.question-logic {
		position: absolute;
		right: 13px;
		top: 28px;
		width: 13px;
		height: 12px;
	}
	
	.select-icon {
		overflow: hidden;
		padding: 0;
	}
	.select-icon .sort-num {
		display: block;
		width: 100%;
		height: 100%;
		background: rgba(34,114,237,1);
		color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewSort.vue